module.exports = __webpack_public_path__ + "static/media/xiaomi_recent_3.47d418c0.jpg";